import Transformer from './../transformer'

class supplyPurchaseOrdenTransformer extends Transformer {
  static fetch(supplies) {
    return {
      supplyId: supplies.supply.supply_id,
      supplyName: supplies.supply.supply_name,
      supplySubFamilyId: supplies.supply.supply_sub_family_id,
      supplySubFamilyName: supplies.supply.supply_sub_family_name,
      supplyFamilyId: supplies.supply.supply_family_id,
      supplyFamilyName: supplies.supply.supply_family_name,
      quantity: supplies.quantity,
      unitPrice: supplies.unit_price,
      id: supplies.id,
      buyOrderPrice: supplies.buy_order_price,
      // Requisitions -> object
      requisitions: supplies.requisitions,
      camp: supplies.camp,
      receive: supplies.receive,
      providers: supplies.providers,
      ConvertABC: 0
    }
  }
}

export default class suppliesTransformer extends Transformer {
  static fetch(order) {
    let supplies = supplyPurchaseOrdenTransformer.fetchCollection(order.supplies)
    return {
      subtotal: order.subtotal,
      subtotalWeigh: 0,
      supplies: supplies
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/purchase/supplies.js